<template>
  <div id="app">
    <keep-alive include="Home">
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
    export default {
        name: "App",
        data() {
            return {};
        },
        created() {
        },
        methods: {
        },
    };
</script>

<style>
* {
  margin: 0;
  padding: 0;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  border: 0;
}
button,
input,
select,
textarea {
  font-size: 100%;
  outline: none;
}
.nowrapELl {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
*::-webkit-scrollbar {
  width: 0.039rem;
}
*::-webkit-scrollbar-track {
  background-color: rgba(173, 173, 173, 0.4);
  -webkit-border-radius: 0.02rem;
  -moz-border-radius: 0.02rem;
  border-radius: 0.02rem;
}
*::-webkit-scrollbar-thumb {
  background: rgba(206, 198, 170, 1);
  -webkit-border-radius: 0.02rem;
  -moz-border-radius: 0.02rem;
  border-radius: 0.02rem;
}
</style>
